export default "__VITE_ASSET__BC83v24E__"